import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Box, Button, Grid, Image, Modal, Select, TextField, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';
import ShapeSVG from '../../assets/images/dashboard/shape.svg';
import WalletSVG from '../../assets/images/dashboard/wallet.svg';

/*
    - api
*/
import post from '../../api/post';
import getAPI from '../../api/get';

const Banner = ({ props, alertProps, reloadDashboardProps }) => {

    const [bankAccount, setBankAccount] = React.useState('empty');
    const [credit, setCredit] = React.useState('3,000,000');
    const [lowCreditError, setLowCreditError] = React.useState(false);
    const [walletBalance, setWalletBalance] = React.useState('loading');

    const [walletRequestParameters, setWalletRequestParameters] = React.useState({
        accountId: { value: '', color: 'dark' },
        price: { value: '', color: 'dark' }
    });

    React.useEffect(() => {
        if (props.walletBalance.status === 200) {
            setWalletBalance(props.walletBalance.data);
        }
        if (props.bankAccount.status === 200) {
            setBankAccount(props.bankAccount.data);
        }
    }, [props]);

    const walletRequestHandler = (key, value) => {
        if (key === 'accountId') {
            setWalletRequestParameters(prev => ({
                ...prev,
                accountId: { value, color: 'dark' }
            }));
        }
        if (key === 'price') {
            setWalletRequestParameters(prev => ({
                ...prev,
                price: { value, color: 'dark' }
            }));
        }
    };

    const chargeWallet = async () => {
        const cleanCredit = credit.replaceAll(',', '');
        if (parseInt(cleanCredit) >= 100000) {
            const GetTokenParameters = {
                ctrl: 'payment/Wallet',
                method: 'GetToken/44',
                query: cleanCredit * 10
            };
            const res = await getAPI(GetTokenParameters);
            window.location.replace(`/api/mvc/payment/Wallet/GotoParsianIPG/${res.data.orderId}`);
        } else {
            setLowCreditError(true);
        }
    };

    const walletRequest = async () => {
        let isValid = 1;
        if (walletRequestParameters.accountId.value === '') {
            setWalletRequestParameters(prev => ({
                ...prev,
                accountId: { ...prev.accountId, color: 'danger' }
            }));
            isValid = 0;
        }

        if (isValid === 1) {
            const body = {
                AccountId: walletRequestParameters.accountId.value,
                Price: walletRequestParameters.price.value === ''
                    ? walletBalance.CashBalance
                    : walletRequestParameters.price.value * 10
            };

            const parameters = {
                ctrl: 'UserProfile',
                method: 'WalletRequest',
                query: '',
                body
            };

            const result = await post(parameters);
            if (result.status === 200) {
                alertProps(['success', 'با موفقیت انجام شد']);
                reloadDashboardProps(`${Math.floor(Math.random() * 100)},banner`);
            } else {
                alertProps(['danger', result.data.Message]);
            }
            closeModal('walletRequestModal');
            setWalletRequestParameters(prev => ({ ...prev, price: { value: '', color: 'dark' } }));
        }
    };

    const openModal = (modal) => {
        document.querySelector(`.${modal}`).classList.remove('d-none');
    };

    const closeModal = (modal) => {
        if (modal === 'chargeWalletModal') {
            setCredit('3,000,000');
            setLowCreditError(false);
        }
        document.querySelector(`.${modal}`).classList.add('d-none');
    };

    // فرمت کردن موجودی برای نمایش در توضیحات مودال
    const formatBalance = (balance) => balance !== 'loading' ? `${(Math.floor(balance) / 10).toLocaleString()} تومان` : '';

    return (
        <React.Fragment>
            <Box
                className="my-lg mt-0 rounded-lg overflow-hidden position-relative"
                ms={{
                    height: '193px',
                    background: 'linear-gradient(to bottom, #4B79A1, #283E51)',
                    '@media(max-width:568px)': { height: '143px' }
                }}>
                <Box className="w-100 h-100 position-absolute">
                    <Image src={ShapeSVG} alt="shape" ms={{ width: '120%' }} />
                </Box>
                <Box
                    className="position-absolute transform-vertical-center left-xxl"
                    ms={{ '@media(max-width:768px)': { left: '0.75rem' } }}>
                    <Image src={WalletSVG} alt="banner-wallet" ms={{ width: '140px', height: 'auto' }} />
                </Box>
                <Box
                    className="position-absolute transform-vertical-center right-xxl"
                    ms={{ '@media(max-width:768px)': { right: '0.75rem' } }}>
                    <Box className="d-flex align-item-center">
                        <Typography className="d-block text-white" ms={{ width: '136px' }}>
                        موجودی حساب من
                        </Typography>
                        <Box className="mx-lg" />
                        <Typography className="d-block text-white" component="h4">
                            {walletBalance !== 'loading' && `${(Math.floor(walletBalance.Balance) / 10).toLocaleString()} تومان`}
                            {walletBalance === 'loading' && <Image src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} className="d-inline" />}
                        </Typography>
                    </Box>
                    <Box className="d-flex align-item-center">
                        <Typography className="d-block text-white" ms={{ width: '136px' }}>
                        مبلغ قابل برداشت
                        </Typography>
                        <Box className="mx-lg" />
                        <Typography className="d-block text-white" component="h4">
                            {walletBalance !== 'loading' && `${(Math.floor(walletBalance.CashBalance) / 10).toLocaleString()} تومان`}
                            {walletBalance === 'loading' && <Image src={LoadingCustomSVG} ms={{ width: '20px', height: '20px' }} className="d-inline" />}
                        </Typography>
                    </Box>
                    <Box className="d-flex my-xl mb-0">
                        <Button onClick={() => openModal('walletRequestModal')} color="peace" size="sm">
                        تسویه موجودی
                        </Button>
                        <Box className="mx-sm" />
                        <Button onClick={() => openModal('chargeWalletModal')} variant="outlined" color="peace" size="sm">
                        افزایش موجودی
                        </Button>
                    </Box>
                </Box>
            </Box>

            {/* تسویه موجودی */}
            <Modal className="walletRequestModal">
                <Modal.Wrapper size="xs" ms={{ '@media(max-width:576px)': { width: 'calc(100% - 12px) !important' } }}>
                    <Modal.Header className="border-solid-bottom border-light">
                        تسویه موجودی
                        <Box />
                    </Modal.Header>
                    <Box className="my-md mt-0" />
                    <Typography className="px-lg">
                        مبلغ قابل برداشت کیف پول شما {formatBalance(walletBalance.Balance)} است. در صورت تمایل این موجودی به شماره حسابی که از لیست زیر انتخاب می کنید، واریز خواهد شد.
                    </Typography>
                    <Grid>
                        <Grid.Wrapper className="px-sm">
                            <Grid.Item size="col-12">
                                <Select
                                    onChange={(e) => walletRequestHandler('accountId', e)}
                                    color={walletRequestParameters.accountId.color}
                                    placeholder='انتخاب حساب'>
                                    {bankAccount !== 'empty' && bankAccount.map((obj, index) => (
                                        <Select.Item key={index} value={obj.Id}>
                                            {obj.CardNumber.toString().replace(/\B(?=(\d{4})+(?!\d))/g, '-')}
                                        </Select.Item>
                                    ))}
                                </Select>
                            </Grid.Item>
                            <Grid.Item size="col-12">
                                <TextField
                                    onChange={(e) => walletRequestHandler('price', e)}
                                    color={walletRequestParameters.price.color}
                                    placeholder='مبلغ دلخواه'
                                    value={walletRequestParameters.price.value}
                                />
                            </Grid.Item>
                            <Grid.Item className="d-flex" size="col-10 col-md-6">
                                {walletBalance.CashBalance > 0 && (
                                    <Button onClick={walletRequest} variant="filled" color="primary">
                                        تسویه موجودی
                                    </Button>
                                )}
                                {walletBalance.CashBalance !== 0 && <Box className="mx-sm" />}
                                {walletBalance.CashBalance === 0 && (
                                    <Button variant="filled" color="primary" disabled ms={{ background: 'var(--gray-light) !important' }}>
                                        غیر فعال
                                    </Button>
                                )}
                                {walletBalance.CashBalance === 0 && <Box className="mx-sm" />}
                                <Button onClick={() => closeModal('walletRequestModal')} variant="outlined" color="danger">
                                            انصراف
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Modal.Wrapper>
            </Modal>

            {/* افزایش موجودی */}
            <Modal className="chargeWalletModal">
                <Modal.Wrapper size="xs" ms={{ '@media(max-width:576px)': { width: 'calc(100% - 12px) !important' } }}>
                    <Modal.Header className="border-solid-bottom border-light">
                        افزایش موجودی
                        <Box />
                    </Modal.Header>
                    <Box className="my-md mt-0" />
                    <Typography className="px-lg">
                        موجودی فعلی کیف پول شما {formatBalance(walletBalance.CashBalance)} است. در صورت تمایل می توانید از لیست زیر اقدام به افزایش موجودی خود نمایید.
                    </Typography>
                    <Grid>
                        <Grid.Wrapper className="px-sm">
                            <Grid.Item size="col-12 xl-4">
                                <Button onClick={() => setCredit('3,000,000')} className="w-100" variant="outlined" color="primary" size="sm" ms={{ fontSize: '12px' }}>
                                    3,000,000 تومان
                                </Button>
                            </Grid.Item>
                            <Grid.Item size="col-12 xl-4">
                                <Button onClick={() => setCredit('5,000,000')} className="w-100" variant="outlined" color="primary" size="sm" ms={{ fontSize: '12px' }}>
                                    5,000,000 تومان
                                </Button>
                            </Grid.Item>
                            <Grid.Item size="col-12 xl-4">
                                <Button onClick={() => setCredit('10,000,000')} className="w-100" variant="outlined" color="primary" size="sm" ms={{ fontSize: '12px' }}>
                                    10,000,000 تومان
                                </Button>
                            </Grid.Item>
                            <Grid.Item size="col-12">
                                {lowCreditError && (
                                    <Alert className="position-static" color="danger" ms={{ boxShadow: 'none' }}>
                                        حداقل مبلغ شارژ کیف پول 100,000 تومان است.
                                    </Alert>
                                )}
                                <TextField
                                    onChange={setCredit}
                                    label='سایر مبالغ (تومان)'
                                    placeholder='سایر مبالغ (تومان)'
                                    hint='حداقل مبلغ شارژ کیف پول 100,000 تومان است.'
                                    value={credit}
                                />
                            </Grid.Item>
                            <Grid.Item className="d-flex" size="col-10 col-md-6">
                                <Button onClick={chargeWallet} variant="filled" color="primary">
                                    افزایش موجودی
                                </Button>
                                <Box className="mx-sm" />
                                <Button onClick={() => closeModal('chargeWalletModal')} variant="outlined" color="danger">
                                    انصراف
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>
                    </Grid>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment>
    );
};

export default Banner;